import { cn } from '@lib/utils';

interface TitleProps extends Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'title'
> {
  title: React.ReactNode;
}

export default function Title({ title, className, ...rest }: TitleProps) {
  const baseClassName =
    'font-semibold text-4xl leading-[44px] tracking-[-0.784px] md:text-5xl md:leading-[72px] md:tracking-[-1.344px]';

  return (
    <div className={cn(baseClassName, className)} {...rest}>
      {title}
    </div>
  );
}
